import classNames from 'classnames'
import { Card, CardBody } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { TIPI_INTERVENTO } from '../../constants'
import { Proposta } from '../../types'

interface PropostaDettaglioInterface {
  id: Proposta['id']
  tipo_intervento: Proposta['tipo_intervento']
  cliente_pk: Proposta['cliente_pk']
  cliente_ragione_sociale: Proposta['cliente_ragione_sociale']
  sede_data: Proposta['sede_data']
}

type CardDettaglioProps = {
  proposta: PropostaDettaglioInterface | undefined
}

export default function CardDettaglio({ proposta }: CardDettaglioProps) {
  return (
    <Card>
      <CardBody>
        <div className="heading-h4 d-flex align-items-center">
          <span className="material-icons text-secondary me-1">edit</span> Dettagli proposta
        </div>
        <div className="mt-3">
          <div className="label-m">Tipo intervento</div>
          <div
            className={classNames('p-md mt-2 badge w-max-content', {
              'bg-rapporto-taratura-light': proposta?.tipo_intervento === 'rapporto_taratura',
              'bg-intervento-periodico-light': proposta?.tipo_intervento === 'verifica_periodica',
              'text-rapporto-taratura': proposta?.tipo_intervento === 'rapporto_taratura',
              'text-intervento-periodico': proposta?.tipo_intervento === 'verifica_periodica',
            })}
            style={{ width: 'max-content' }}
          >
            {TIPI_INTERVENTO.find((t) => t.value === proposta?.tipo_intervento)?.label ?? proposta?.tipo_intervento}
          </div>
        </div>
        <div className="mt-3">
          <div className="label-m">Cliente</div>
          <div className="p-md mt-2">
            <Link to={`/clienti/${proposta?.cliente_pk}`} className="link-md">
              {proposta?.cliente_ragione_sociale}
            </Link>
          </div>
        </div>
        {proposta?.sede_data.codice_sdi && (
          <div className="mt-3">
            <div className="label-m">Codice sdi</div>
            <div className="p-md mt-2">{proposta?.sede_data.codice_sdi ?? '-'}</div>
          </div>
        )}
        <div className="mt-3">
          <div className="label-m">Sede</div>
          <div className="p-md mt-2">
            {proposta?.sede_data.toponimo_data?.nome} {proposta?.sede_data.via}, {proposta?.sede_data.civico} -{' '}
            {proposta?.sede_data.comune_data?.nome} ({proposta?.sede_data.provincia_data?.sigla})
          </div>
        </div>
        <div className="mt-3">
          <div className="label-m">Telefono</div>
          <div className="p-md mt-2">{proposta?.sede_data.telefono ?? '-'}</div>
        </div>
        {proposta?.sede_data.nome_referente && (
          <div className="mt-3">
            <div className="label-m">Nome referente</div>
            <div className="p-md mt-2">{proposta?.sede_data.nome_referente ?? '-'}</div>
          </div>
        )}
        {proposta?.sede_data.numero_rea && (
          <div className="mt-3">
            <div className="label-m">Numero Rea</div>
            <div className="p-md mt-2">{proposta?.sede_data.numero_rea ?? '-'}</div>
          </div>
        )}
      </CardBody>
    </Card>
  )
}
